// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3dAiQ"};